<template>
  <div class="container" v-if="!this.isMobile">
    <div class="inner bg-white">
      <loading :active.sync="isLoading" :can-cancel="true"></loading>
      <flash-message class="myCustomClass"></flash-message>
      <div class="col-vcenter-block">
        <div class="row">
          <div class="col-md-12 text-center">
            <div v-if="ciframe_loader == true" class="kploader"></div>
            <div
              v-if="ciframe_loader == true"
              style="margin: 10px; font-weight: 900"
            >
              WE ARE PROCESSING YOUR PAYMENT
            </div>
            <p v-if="ciframe_loader == true">
              This may take a moment. Please do not refresh the page.
            </p>
            <div v-if="ddc_form">
              <iframe
                id="devicedataIframe"
                name="devicedataIframe"
                height="1"
                width="1"
                style="display: none"
              >
              </iframe>
              <form
                id="collectionForm"
                name="devicedata"
                method="POST"
                target="devicedataIframe"
                :action="deviceDataCollectionData.redirect_data.url"
              >
                <input
                  type="hidden"
                  name="Bin"
                  v-model="deviceDataCollectionData.redirect_data.bin"
                />
                <input
                  type="hidden"
                  name="JWT"
                  v-model="deviceDataCollectionData.redirect_data.jwt"
                />
                <!-- <input type="submit" value="Submit" /> -->
                <script type="application/javascript">
                  document.getElementById("collectionForm").submit();
                </script>
              </form>
            </div>
            <div v-if="threeds_form" class="iparent">
              <form
                id="challengeForm"
                name="challengeForm"
                method="POST"
                target="challengeIframe"
                :action="challengeData.url"
              >
                <input type="hidden" name="JWT" v-model="challengeData.jwt" />
                <input
                  type="hidden"
                  name="MD"
                  v-model="transaction_reference"
                />
                <script type="application/javascript">
                  <!-- document.getElementById("challengeForm").submit(); -->
                </script>
              </form>
              <iframe
                id="challengeIframe"
                name="challengeIframe"
                frameBorder="0"
                @load="challengeIframeLoaded"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="spacer-y"></div>
    <pageBottom></pageBottom>
  </div>
  <div class="container py-30 inner bg-white" v-else>
    <flash-message class="myCustomClass"></flash-message>
    <loading :active.sync="isLoading" :can-cancel="true"></loading>
    <div class="col-vcenter-block">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="kploader"></div>
          <div style="margin: 10px; font-weight: 900">
            WE ARE PROCESSING YOUR PAYMENT
          </div>
          <p>This may take a moment. Please do not refresh the page.</p>
          <div v-if="ddc_form">
            <iframe
              id="devicedataIframe"
              name="devicedataIframe"
              height="1"
              width="1"
              style="display: none"
            >
            </iframe>
            <form
              id="collectionForm"
              name="devicedata"
              method="POST"
              target="devicedataIframe"
              :action="deviceDataCollectionData.redirect_data.url"
            >
              <input
                type="hidden"
                name="Bin"
                v-model="deviceDataCollectionData.redirect_data.bin"
              />
              <input
                type="hidden"
                name="JWT"
                v-model="deviceDataCollectionData.redirect_data.jwt"
              />
              <!-- <input type="submit" value="Submit" /> -->
              <script type="application/javascript">
                document.getElementById("collectionForm").submit();
              </script>
            </form>
          </div>
          <div v-if="threeds_form" class="iparent">
            <form
              id="challengeForm"
              name="challengeForm"
              method="POST"
              target="challengeIframe"
              :action="challengeData.url"
            >
              <input type="hidden" name="JWT" v-model="challengeData.jwt" />
              <input type="hidden" name="MD" v-model="transaction_reference" />
              <script type="application/javascript">
                <!-- document.getElementById('challengeForm').submit(); -->
              </script>
            </form>
            <iframe
              id="challengeIframe"
              name="challengeIframe"
              frameBorder="0"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
require("vue-flash-message/dist/vue-flash-message.min.css");
import Vuelidate from "vuelidate";
import VueFlashMessage from "vue-flash-message";
import Payment from "@/services/Payment";
Vue.use(Vuelidate);
Vue.use(VueFlashMessage);
import Helper from "../../helper.js";
import pageBottom from "./pageBottom.vue";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import UserMixin from "../mixins/UserMixin";
export default {
  name: "checkout",
  mixins: [Helper, UserMixin],
  data() {
    return {
      ddc_form: false,
      threeds_form: false,
      isLoading: false,
      isShowing: false,
      deviceDataCollectionData: this.$store.state.deviceDataCollectionData,
      deviceDataCollectionResponse: false,
      deviceWindow: false,
      challengeData: {},
      ciframe_loaded: false,
      ciframe_loader: true,
      transaction_reference: "",
      cartPrice:
        localStorage.getItem("trainingCoursePrice") != null
          ? localStorage.getItem("trainingCoursePrice")
          : localStorage.getItem("totalPrice"),
    };
  },
  validations: {},
  components: {
    Loading,
    pageBottom,
  },
  mounted() {
    if (this.deviceDataCollectionData) {
      this.ddc_form = true;
    }
    window.addEventListener("message", this.receiveMessage);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.receiveMessage);
  },
  methods: {
    showWPError(message,_this){
       _this.isLoading = false;
      _this.flash(message, "error", {timeout: 4000});
      _this.$router.push({ name: "confirm", query: { message: 'failed' } });
    },
    challengeIframeLoaded() {
      if (this.ciframe_loaded == false) {
        this.ciframe_loaded = true;
        document.getElementById("challengeForm").submit();
        window.addEventListener("message", this.receiveMessage);
      }
      //
    },
    receiveMessage(message) {
      var _this = this;
      console.log("MEssage:", message);
      if (document.getElementById("devicedataIframe")) {
        var msg = JSON.parse(message.data);
        if ('MessageType' in msg) {
          window.removeEventListener("message", _this.receiveMessage);
          Payment.handleDeviceDataResponse(
            _this.deviceDataCollectionData.transaction_reference,
            JSON.parse(message.data),
            _this.cartPrice
          )
            .then((resp) => {
              _this.$store.commit({ type: "clear3DSiframeData" });
              if (resp.data.success) {
                var store = _this.$store;
                var route = _this.$router;
                for (let item of store.state.cart) {
                  store.commit("confirm", item);
                }
                _this.isLoading = false;
                let mesg = "failed";
                if (resp.data.order.payment_status == "Paid") {
                  mesg = "success";
                }
                route.push({ name: "confirm", query: { message: mesg } });
              } else if ("redirect_data" in resp.data) {
                _this.threeds_form = true;
                _this.challengeData = resp.data.redirect_data;
                _this.transaction_reference = resp.data.transaction_reference;
                _this.ddc_form = false;
                this.ciframe_loader = false;
              } else {
                route.push({ name: "confirm", query: { message: "failed" } });
              }
            })
            .catch((error) => {
              console.log('EER',error);
              _this.showWPError('Failed to process the payment. Please contact us for support.(CODE:0001)',_this);
            });
        }
      }
      if (message.origin == process.env.VUE_APP_API_BASE_URL) {
        _this.isLoading = true;
        this.ciframe_loader = true;
        window.removeEventListener("message", this.receiveMessage);
        Payment.authorizeThreeds(
          this.deviceDataCollectionData.transaction_reference,
          JSON.parse(message.data),
          this.cartPrice
        )
          .then((resp) => {
            if (resp.data.success) {
              var store = _this.$store;
              var route = _this.$router;
              for (let item of store.state.cart) {
                store.commit("confirm", item);
              }
              _this.isLoading = false;
              let mesg = "failed";
              if (resp.data.order.payment_status == "Paid") {
                mesg = "success";
              }
              route.push({ name: "confirm", query: { message: mesg } });
            } else {
              route.push({ name: "confirm", query: { message: "failed" } });
            }
          })
          .catch((error) => {
            console.log('EER2',error);
            _this.showWPError('Failed to process the payment. Please contact us for support.(CODE:0002)',_this);
          });
      }
    },
  },
};
</script>
<style type="text/css">
.col-vcenter-block {
  float: none;
  display: block;
  margin-top: 5%;
  margin-bottom: 5%;
}
.kploader {
  float: none;
  display: block;
  margin-left: auto;
  margin-right: auto;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #1f5ea9;
  width: 60px;
  height: 60px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}
.kpfooter {
  position: absolute;
  text-align: center;
  left: 0;
  bottom: 0;
  width: 100%;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.iparent {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.iparent iframe {
  border: none;
  flex-grow: 1;
}
</style>